import {useGlobalStore} from "@/stores/useGlobalStore";
import usePayloadBuilder from "@/usePayloadBuilder";

export default function useReturnValue() {
    const globalStore = useGlobalStore()

    function setSLAccountDetail(code, key) {
        let selected_account = globalStore.slAccounts.filter(account => account.code === code)
        if(selected_account[0] !== undefined) {
            return selected_account[0][key]
        }
    }

    function setGLAccountDetail(code, key) {
        let selected_account = globalStore.glAccounts.filter(account => account.code === code)
        if(selected_account[0] !== undefined) {
            return selected_account[0][key]
        }
    }

    function setBranchDetail(code, key) {
        let branch = globalStore.branches.filter((obj) => { return obj.code === code })
        if(branch[0]){
            return branch[0][key]
        }
    }

    function setTaxTypeDetail(code, key) {
        let selected_tax = globalStore.tax_types.find(account => account.code === code)
        if(selected_tax) return selected_tax[key]

        return code
    }

    function setWTaxTypeValue (code) {
        const tax_type = globalStore.taxes.find(tax => tax.code === code)
        if(tax_type) return tax_type.percent
        return code
    }

    function setModeOfPaymentDetail(code, key){
        let option = globalStore.modes.filter(opt => opt.code === code)
        if(option[0] !== undefined) {
            return option[0][key]
        }
    }

    function setColumns(columns) {
        let custom_columns = []
        for(const key of Object.keys(columns)){
            let obj = {}
            obj[key] = columns[key].name
            if(columns[key].name) custom_columns.push(obj)
        }

        return custom_columns
    }

    function getSelectedColumns(custom_columns) {
        let selected_columns = []

        for(const key of Object.keys(custom_columns)) {
            selected_columns.push(Object.keys(custom_columns[key]).toString())
        }

        return selected_columns
    }

    function foreignCurrencyConversion(currency, amount) {
        if(currency !== 'PHP') {
            // TODO: Retrieve conversion rate from API and return conversion rate back to object to pass today's conversion rate
            let conversion_rate = 1
            amount = parseFloat(String(amount).replaceAll(',',''))
            return amount * conversion_rate
        }

        return amount
    }

    async function requestForex() {
        let currency_details = {}
        let response = await usePayloadBuilder('forex', 'list').execute()
        if(response) {
            if(response.data.code) return 1
            let rates = response.data.data
            rates.forEach(rate => {
                currency_details[rate.currency] = rate.rate
            })

            return currency_details
        }
    }

    async function returnForeignCurrencyConversionRate(currency, amount) {
        let conversion = await requestForex()
        let conversion_rate = 1
        if(currency !== 'PHP') {
            conversion_rate = conversion[currency] ?? 1
            amount = parseFloat(String(amount).replaceAll(',',''))
            amount = amount * conversion_rate
        }

        return {
            amount: parseFloat(String(amount).replaceAll(',','')).toFixed(2),
            conversion_rate: conversion_rate.toFixed(2)
        }
    }

    function returnUserDetails(key) {
        let user_details = JSON.parse(localStorage.getItem('authUser'))

        return user_details[key]
    }

    function returnSplitValue(data, separator, array_key) {
        let initial_data = data.split(separator)

        return initial_data[array_key]
    }

    return {
        setSLAccountDetail,
        setTaxTypeDetail,
        setGLAccountDetail,
        setBranchDetail,
        setModeOfPaymentDetail,
        setColumns,
        getSelectedColumns,
        foreignCurrencyConversion,
        returnForeignCurrencyConversionRate,
        returnUserDetails,
        returnSplitValue,
        setWTaxTypeValue
    }
}
